

/* API定义 */
const myApi = {
    captcha: "/user/captcha",  //验证码
    login: "/user/login",  //登录
    logout: "/user/logout",  //登出
    alterPass: "/user/alterPass",  //修改密码
    permissionMenu: "/menu/getPermissionMenu",  //获取用户权限菜单
    permissionButton: "/getPermissionButton",  //获取用户权限按钮
    getUserInfo: "/user/getUserInfo",  //获取当前登录用户信息
    keyPerStationList:"perStatList", //权限电站列表

    getOneUserInfo: "/user/getOne", //根据id查询一条用户信息(新)

    //通用字典
    getChildDictbyParcode:"/dict/getByParType", //根据父级类型码查询字典
    getCommValSign: "/dict/getCommValSign", //获取通用状态标记
    getDeleteSign:"dict/getFileDeleteSign", //删除标记

    //数据字典模块
    dictManGetList: "/dict/getList",  //数据管理分页查询
    dictManDel: "/dict/delete",  //记录删除
    dictManGetById: "/dict/getById", //记录详情
    dictManAlter: "/dict/alter",  //修改
    dictManAdd: "/dict/add",  //添加

    dictGetSysName: "/dict/getSysName",   //获取系统标题名称
    dictGetLarName: "/dict/getLarName",  //大屏标题名称
    dictGetStaState: "/dict/getStaState",  //获取电站状态集合
    dictGetTypeList: "/dict/getTypeList",  //获取字典类型集合
    dictGetUserState: "/dict/getUserState",  //查询用户状态类型集合
    dictGetTypeTreeList:"/dict/getTypeTree", //获取字典类型集合树结构

    getControlInputForm: "/dict/getControlInputForm", //获取控制页面控制量输入的方式
    getDecimalLen: "/dict/getDecimalLen", //获取小数位长度
    getControlVerifySign: "/dict/getControlVerifySign", //获取控制模块校验启用标记
    getDisplaySign: "/dict/getDisplaySign",//获取显示状态
    getRegExpList: "/dict/getSysRegular", //获取正则表达式列表

    getAnalysisWay: "/dict/getAnalysisWay", //获取数据解析方式
    getEnableSign: "/dict/getEnableSign", //获取生效标记
    getDevType: "/dict/getDevType", //获取设备类型
    getDataType: "/dict/getDataType", //获取数据类型列表
    getChartDataType:"/dict/getChartDataType", //获取图表的数据类型
    getRemoteSign: "/dict/getRemoteSign", //获取四遥列表
    getStateSign: "/dict/getStateSign", //获取状态标记
    getDisplayForm: "/dict/getDisplayForm", //获取显示形式列表
    getDisplayIcon: "/dict/getDisplayIcon", //获取图标列表
    getStateSignState: "/dict/getStateSignState",//获取状态码数据据点状态标记
    getStateColor: "/dict/getStateColor",
    getStateSignCode: "/dict/getStateSignCode", //获取状态码和告警码
    getIsCheck: "/dict/getPtStateCheck", //获取当前是否选中
    getCodeLevel: "/dict/getCodeLevel", //获取告警级别

    getTableTypeList: "/dict/getTableType", //查询表类型列表
    getNullSignList: "/dict/getNullSign", //查询空表标记列表
    getTestStateList: "/dict/getTestState", //查询检测状态列表

    getSysType: "/dict/getDevSysType", //获取系统类型
    getMeterSign: "/dict/getDevMeterSign", //获取电表标记
    getDevUpDownDataSign: "/dict/getDevUpDownDataSign", //获取上行数据标记
    detectionSign: "/dict/detectionSign", //获取告警变位越限标记
    getHistorySign: "/dict/getDevHistorySign ", //获取历史数据存储标记
    getDevState: "/dict/getDevState",//获取设备状态

    getClimateZoneList: "/dict/getClimateZone", //获取气候区列表
    getInverterTypeList: "/dict/getInverterType", //获取逆变器类型列表
    getComponentTypeList: "/dict/getComponentType", //获取组件类型列表
    getBracketTypeList: "/dict/getBracketType", //获取支架列表
    getDataLoadWayList: "/dict/getRealTimeDataLoadWay", //获取实时数据加载列表
    getMapStateList: "/dict//getMapState", //获取地图显示状态
    getCommState: "dict/getCommState", //获取电站通讯状态
    getCommWay: "dict/getCommWay ", //获取电站通讯方式
    getGridMode: "dict/getGridMode ", //获取电站并离网模式
    getStaType: "dict/getStaType ", //获取电站类型

    getRealDataRefInterval: '/dict/getRealDataRefInterval', //设备详情页获取数据刷新间隔
    getMqttConnInfo: '/dict/getMqttConnInfo', //设备详情页获取mqtt配置信息
    getTopicDevRtd: "/dict/getTopicDevRtd", //获取设备实时数据主题前缀
    getAlarmStateSign: "/dict/getAlarmStateSign", //获取实时告警状态标记
    getConfirmState: "/dict/getConfirmState", //获取实时告警确认状态

    getOperateSign: "dict/getOperateSign", //获取用户的操作标记(修改,删除,添加)
    getUserSign: "/dict/getUserSign", //获取用户标记
    getSysTypeList: "/dict/getSysType", //获取系统类型
    getMenuTypeList: "/dict/getMenuType", //获取菜单类型
    getMenuLevalList: "/dict/getMenuLevel", //获取菜单级别
    getMenuSignList: "/dict/getMenuSign", //获取菜单标记
    getCompanyType: "/dict/getCompanyType", //获取单位类型
    getEMSsysName: "/dict/getSysEMSName", //获取EMS的系统名称

    //图表字典
    getSelSign: "/dict/getSelSign", //获取选择标记
    getBelongType: "/dict/getBelongType", //获取归属类型
    getYAxisType: "/dict/getYAxisType", //获取Y坐标类型
    getDevModule: "/dict/getDevModule", //获取设备模块类型
    getStaModule: "/dict/getStaModule", //获取电站模块类型
    getCharDisplayType: "/dict/getCharDisplayType", //获取图表显示类型
    getValDisplay:"/dict/getValDisplay", //获取最新值显示标记
    getChartAxisSign:"/dict/getChartAxisSign", //获取图表坐标标记
    getDataModelSign:"/dict/getDataModelSign", //获取模块标记

    //曲线字典
    getCalculationWay: "/dict/getCalculationWay",  //获取曲线计算方式
    getRealTimePush: "/dict/getRealTimePush",  //获取曲线实时推送
    getValueWay: "/dict/getValueWay",  //获取曲线取值方式
    getDisplayColor: "/dict/getDisplayColor",  //获取显示颜色
    getDisplayType: "/dict/getDisplayType",  //获取显示类型
    getCurveInvalidLogic: "/dict/getCurveInvalidLogic",  //获取曲线无效逻辑类型

    //累积量字典
    getPriceSign: "/dict/getPriceSign", //获取电价的参与标记
    getTimeHourSign: "/dict/getTimeHourSign", //获取时间公式标记
    getReduceSecond: "/dict/getReduceSecond", //获取数据查询偏移秒
    getCalculationType: "/dict/getCalculationType", //获取计算类型
    getValueType: "/dict/getValueType", //获取原始值类型

    //电站分组字典
    getReadCfgType: "/dict/getReadCfgType", //获取配置数据读取类型

    //电站静态信息
    getStationStaticInfo: "/dict/getStationStaticInfo", //获取电站静态信息码
    getSysOveSign: "/dict/getSysOveSign", //获取系统总览页面显示标记

    //电站配置信息
    getStationConfig: "/dict/getStationConfig", //获取电站配置信息码


    //拓扑图字典
    getTopologyType: "/dict/getTopologyType",  //获取拓扑图类型
    getTopologyPointDataModel: "/dict/getTopologyPointDataModel",  //获取拓扑图类型

    //EMS数据配置字典
    getEmsSourceType: "/dict/getEmsSourceType",//获取EMS源类型
    getEmsModelType: "/dict/getEmsModelType",//获取EMS模块标记
    getEmsCumulateType: "/dict/getEmsCumulateType",//获取EMS累积量类型

    //单位数据
    comGetPermissionCompany: "/com/getPermissionCompany",  //获取权限范围内单位集合
    getCompanyInfoById: "/com/getInfoById",  //获取单位信息

    getLoginUserCompanyTree: "/company/getLoginUserCompanyTree",  //获取当前登录 用户单位及下级单位树状集合
    getLoginUserCompanyList: "/company/getLoginUserCompanyList",  //获取当前登录 用户单位及下级单位list集合
    getMenuListAll: "/company/getMenuListAll",  //查询所有单位菜单信息
    manCompanyGetList: "/company/getList",  //查询所有单位集合，分页形式
    manCompanyAdd: "/company/add",
    manCompanyDel: "/company/delete/",
    manCompanyAlter: "/company/alter/",
    manCompanyGetById: "/company/getById/",
    getCompanyInfo: "/com/info/busGetList", //获取单位的静态信息(新)

    // 用户管理
    // manUserGetList: "/user/getList",  //查询用户集合，分页形式
    // manUserDel: "/user/delete/",  //删除用户
    // manUserGetById: "/user/getById/",  //查询一条记录
    // manUserResetPass: "/user/resetPass/",  //重置密码
    // manUserAdd: "/user/add",
    // manUserAlter: "/user/alter",
    //新格式定义
    userManGetList: "/user/getList",  //数据管理分页查询
    userManGetById: "/user/getById/",  //查询一条记录
    userManDel: "/user/delete",  //删除
    userManAlter: "/user/alter",  //修改
    userManAdd: "/user/add",
    userManResetPass: "/user/resetPass", //重置密码


    //角色管理
    roleGetListByComIdArr: "/role/getListByComIdArr",  //根据单位id数组查询角色集合
    getRoleByComId: "/role/getRoleByComId/",  //根据单位id查询角色集合（包括公有角色和私有角色）

    //系统/电站管理
    manSystemAdd: "/system/add",
    manSystemDel: "/system/delete/",
    manSystemAlter: "/system/alter/",
    manSystemGetList: "/system/getList",
    manSystemGetById: "/system/getById/",
    getSysListByComIdArr: "/system/getListByComIdArr/",  // 根据单位id集合查询电站集合
    getPermissionStation: "/sta/getPermissionStation", //获取权限电站集合
    getCountCapacity: "/system/getCountCapacity",  //获取电站数据量和容量统计数据
    manSystemGetInfoById: "/system/getInfoById/",  //系统总览页获取电站基本信息
    getTopologyOrImage:"/img/getTopologyOrImage",//获取显示拓扑图或图片-最新

    getStationInfoById: "/sta/getInfoById",  //查询电站静态信息

    //系统/电站菜单配置
    manSystemMenuGetList: "/system/menu/getStaMenuList/", //根据系统id查询菜单配置数据
    manSystemMenuAdd: "/system/menu/add", //根据系统id查询菜单配置数据
    manSystemMenuDel: "/system/menu/delete/", //根据系统id查询菜单配置数据

    //新系统接口重定义
    staGetInfoById: "/sta/getInfoById", //根据电站id查询电站信息，电站详情页面和设备详情页面查询电站静态信息使用

    //通讯设备管理
    manDeviceAdd: "/device/add",
    manDeviceDel: "/device/delete/",
    manDeviceAlter: "/device/alter/",
    manDeviceGetList: "/device/getList",
    manDeviceGetById: "/device/getById/",
    manDeviceGetListByStaId: "/device/getListByStaId/",  //根据电站id查询设备
    manDeviceGetPtListByDevId: "/device/getPtListByDevId/",  //根据设备id查询关联的点表数据集合
    getDevInfoById: "/device/getDevInfoById/",  //根据id查询设备信息
    getDevInfoByCode: "/device/getDevInfoByCode/",  //根据设备码查询设备信息

    //新系统api重定义
    // devGetDevAndDevTypeList: "/dev/getDevAndDevTypeList",  //根据电站id查询电站使用的设备类型和设备集合，设备详情页面获取设备选择列表数据使用
    devGetInfoArrById: "/dev/getInfoArrById",  //根据设备id查询设备静态信息并已数组形式返回
    devGetRealTimeDataInfo: "/dev/getRealTimeDataInfo",  //根据设备id查询设备实时数据配置信息
    devGetListByStaId: "/dev/getListByStaId",  //根据电站id查询设备集合

    //点表管理
    manPTAdd: "/point/add",
    manPTDel: "/point/delete/",
    manPTAlter: "/point/alter/",
    manPTGetList: "/point/getList",
    manPTGetById: "/point/getById/",
    ptGetComAndPtByDevType: "/point/getByDevType/",  //根据设备类型码查询单位和点表集合
    ptGetPtListByDevType: "/point/getPtListByDevType/",  //根据设备类型码和单位id查询点表集合
    ptGetPtListByComIdArrDevType: "/point/getPtListByComIdArrDevType/", //根据设备类型码和单位id数组查询点表集合

    //点表数据点管理
    manPTDataAdd: "/point/data/add",
    manPTDataDel: "/point/data/delete/",
    manPTDataAlter: "/point/data/alter/",
    manPTDataGetList: "/point/data/getList",
    manPTDataGetById: "/point/data/getById/",
    ptGetStateList: "/point/data/getStateList/",  //根据点表码查询点表状态量集合
    ptGetAlarmCodeList: "/point/data/getAlarmCodeList/",  //根据点表码查询告警码标记集合

    //点表状态码管理
    manPTStateAdd: "/point/state/add",
    manPTStateDel: "/point/state/delete/",
    manPTStateAlter: "/point/state/alter/",
    manPTStateGetList: "/point/state/getList",
    manPTStateGetById: "/point/state/getById/",

    //点表告警码管理
    manPTAlarmAdd: "/point/alarm/add",
    manPTAlarmDel: "/point/alarm/delete/",
    manPTAlarmAlter: "/point/alarm/alter/",
    manPTAlarmGetList: "/point/alarm/getList",
    manPTAlarmGetById: "/point/alarm/getById/",

    //历史数据存储表管理
    manDataTableAdd: "/data/table/add",
    manDataTableDel: "/data/table/delete/",
    manDataTableAlter: "/data/table/alter",
    manDataTableGetList: "/data/table/getList",
    manDataTableGetById: "/data/table/getById/",
    manDataTableGetDtByPtCode: "/data/table/getDtByPtCode/",  //根据单位id和点表唯一码查询数据存储表集合
    manDataTableTestTable: "/data/table/testTable/",  //检测表状态

    //图表管理
    manChartAdd: "/chart/add",
    manChartDel: "/chart/delete/",
    manChartAlter: "/chart/alter",
    manChartGtList: "/chart/getList",
    manChartGetById: "/chart/getById/",
    manChartGetBaseDataList: "/chart/getBaseDataList/",  //根据系统和设备id查询图表
    manChartGetChartList: "/chart/getChartList/",  //查询图表集合，加载曲线图使用
    manChartGetChartInfoByCode: "/chart/getChartInfoByCode/", // 根据曲线图唯一码查询信息

    //2023-03-03-郝惠-添加
    getDeviceChartList: "/chart/getDeviceChartList", //查询设备图表集合
    getStationChartList: "/chart/getStationChartList",  //查询电站图表集合
    getChartDataList: "/chart/data/getDataListByChartId",  //查询曲线图的数据集合
    getChartHourData: "/chart/data/getChartHourData",  //查询曲线图时维度数据
    getChartDayData: "/chart/data/getChartDayData",  //查询曲线图日维度数据
    getChartMonthData: "/chart/data/getChartMonthData",  //查询曲线图月维度数据
    getChartYearData: "/chart/data/getChartYearData",  //查询曲线图年维度数据
    getChartDataDay: "/chart/data/getChartDataDay",  //查询图表数据-日维度(新接口,替换了上面getChartHourData接口)

    //图表数据管理
    manChartDataAdd: "/chart/data/add",
    manChartDataDel: "/chart/data/delete/",
    manChartDataAlter: "/chart/data/alter",
    manChartDataGtList: "/chart/data/getList",
    manChartDataGetById: "/chart/data/getById/",
    manChartDataGetBaseList: "/chart/data/getBaseList",  //查询图表关联数据的基本信息
    manChartGetChartDataList: "/chart/data/getChartDataList/",  //查询曲线图的曲线数据集合

    //图表数据关联关系管理
    manCtrAdd: "/chart/data/relation/add",
    manCtrDel: "/chart/data/relation/delete/",
    manCtrAlter: "/chart/data/relation/alter/",
    manCtrGetList: "/chart/data/relation/getList",  //关联关系查询
    manCtrGetById: "/chart/data/relation/getById/",

    //设备数据对比模块
    unitContrastGetDevList: "/unitContrast/getDevList/", //查询系统可对比的设备
    unitContrastGetDataList: "/unitContrast/getDataList/", //查询设备可对比的数据

    //历史数据表数据接口
    hisGetDayChartInstant: "/history/getDayChartInstant/",  //根据设备id和点表数据id查询日瞬时值曲线
    hisGetHourChartCumulative: "/history/getHourChartCumulative/", //根据设备id和点表数据id查询日每时柱状图数据
    hisGetDayChartCumulative: "/history/getDayChartCumulative/",  //根据设备id和点表数据id查询月每日柱状图数据
    hisGetMonthChartCumulative: "/history/getMonthChartCumulative/",  //根据设备id和点表数据id查询年每月柱状图数据
    hisGetYearChartCumulative: "/history/getYearChartCumulative/",  //根据设备id和点表数据id查询每年柱状图数据

    //登录日志模块
    logLoginGetList: "/log/login/getList",  //查询登录日志

    //历史数据模块(原始数据)
    // historyGetList: "/history/getList",  //历史数据查询(不能用)
    historyGetList: "/his/getList", //历史数据查询
    historyExcelGetList: "/his/exportList", //历史数据导出excel
    getDevHisDataList: "/dev/getDevHisDataList", //获取历史数据(新接口)
    exportDevHisDataList: "/dev/exportDevHisDataList", //导出历史数据(新接口)

    //新版接口重定义
    hisGetDevLatestRecord: "/his/getDevLatestRecord",  //根据设备id查询最新的一条历史数据

    //图片管理
    manImgGetSystemImageList: "/image/getSystemImageList/",  //获取系统图片集合

    //电站曲线配置模块
    stationCurveGetListBus: "/sta/curve/getListBus",  //查询曲线列表
    getListBusNew: "/sta/curve/getListBusNew",  //查询曲线配置集合，业务功能模块使用
    getStaCurveList: "/sta/curve/getList",  //分页查询数据
    getStaCurveById: "/sta/curve/getById",  //根据id查询记录
    deleteStaCurveById: "/sta/curve/delete",  //根据id删除记录
    deleteStaCurveAndNode: "/sta/curve/deleteAndNode",  //删除记录及节点
    addStaCurve: "/sta/curve/add",  //添加记录
    alterStaCurve: "/sta/curve/alter",  //修改记录
    deleteManyStaCurve: "/sta/curve/deleteMany",  //批量删除记录及节点

    //电站曲线节点
    getCurveNodeList: "/sta/curve/node/getList",  //根据曲线id查询曲线节点数据集合
    addCurveNode: "/sta/curve/node/add",  //根据id添加曲线节点记录
    deleteCurveNode: "/sta/curve/node/deleteMany",  //根据id删除曲线节点记录
    alterCurveNode: "/sta/curve/node/alter",  //根据id修改曲线节点记录
    getOneCurveNodeInfo: "/sta/curve/node/getOne", //根据id查询一条节点信息

    //电站累积量配置模块
    getStaCumulateList: "/sta/cumulate/getList",  //分页查询数据
    stationCumulateGetListBus: "/sta/cumulate/getListBus",  //查询累积量列表

    //电站累积量数据查询和导出
    getHourCurData: "/cal/sta/cum/hour/getTimeSlotChartListByPage", //累积量时数据查询
    getHourCurDataExcel: "/cal/sta/cum/hour/exportList", //累积量时数据excel导出
    getDayCurData: "/cal/sta/cum/day/getTimeSlotChartListByPage", //累积量日数据查询
    getDayCurDataExcel: "/cal/sta/cum/day/exportList", //累积量日数据excel导出
    getMonthCurData: "/cal/sta/cum/month/getTimeSlotChartListByPage", //累积量月数据查询
    getMonthCurDataExcel: "/cal/sta/cum/month/exportList", //累积量月数据excel导出
    getYearCurData: "/cal/sta/cum/year/getTimeSlotChartListByPage", //累积量年数据查询
    getYearCurDataExcel: "/cal/sta/cum/year/exportList", //累积量年数据excel导出
    getAllCurData: "/cal/sta/cum/total/getTimeSlotChartList", //累积量总数据查询
    getAllCurDataExcel: "/cal/sta/cum/total/exportList", //累积量总数据excel导出


    //电站曲线计算数据查询
    calDataStaCurveGetDayChartList: "/cal/sta/ins/cur/getDayChartList",  //查询曲线计算结果数据
    calDataStaCurveGetChartList: "/cal/sta/ins/cur/getTimeSlotChartList",  //查询时间段内曲线数据集合
    getChartTypeData: "/cal/sta/ins/cur/getChartTypeData",  //查询时间段内曲线数据集合(新接口)
    getChartTypeDataNew: "/cal/sta/ins/cur/getChartTypeDataNew",
    getCalCurveIntervalTime: "/dict/getCalCurveIntervalTime",//时间间隔字典
    clearChartTypeDataNew: "/cal/sta/ins/cur/clearChartTypeDataNew", //清除历史图表类型数据缓存(新)
    getCurData: "/cal/sta/ins/cur/getListByPage", //曲线数据查询
    getCurDataNew: "/cal/sta/ins/cur/getListPage", //查询曲线数据(新接口)
    getCurDataExcel: "/cal/sta/ins/cur/exportList", //曲线数据查询excel

    calStaCumHourGetDayChartList: "/cal/sta/cum/hour/getDayChartList",  //查询一日内的时累积量
    calStaCumDayGetMonthChartList: "/cal/sta/cum/day/getMonthChartList",  //查询一日内的时累积量
    calStaCumMonthGetYearChartList: "/cal/sta/cum/month/getYearChartList",  //查询一日内的时累积量
    calStaCumYearGetAllChartList: "/cal/sta/cum/year/getAllChartList",  //查询一日内的时累积量
    
    getAllChartListByIdArr: "/cal/sta/cum/year/getAllChartListByIdArr",  //查询所有年累积量(新)
    getYearChartListByIdArr: "/cal/sta/cum/month/getYearChartListByIdArr",  //查询一年内的月累积量(新)
    getMonthChartListByIdArr: "/cal/sta/cum/day/getMonthChartListByIdArr",  //查询一月内的日累积量(新)
    getDayChartListByIdArr: "/cal/sta/cum/hour/getDayChartListByIdArr",  //查询一日内的时累积量(新)
    
    //郧西电站定制接口
    priYunxiGetPower: "/pri/yunxi/getPower",  //查询功率数据列表
    // priYunxiGetCurve34: "/pri/yunxi/getCurve34",  //获取34号区模块发电功率曲线数据
    // priYunxiGetCurve52: "/pri/yunxi/getCurve52",  //获取34号区模块发电功率曲线数据
    // priYunxiGetCurve62: "/pri/yunxi/getCurve62",  //获取34号区模块发电功率曲线数据
    priYunxiGetCurve90: "/pri/yunxi/getCurve90",  //获取34号区模块发电功率曲线数据
    priYunxiGetEnergy: "/pri/yunxi/getEnergy",  //查询发电量数据列表
    priYunxiGetEnv: "/pri/yunxi/getEnv",  //查询环境监测仪列表数据
    priYunxiGetEnvCurve: "/pri/yunxi/getEnvCurve",  //查询环境监测仪曲线数据
    priYunxiGetModule10kw: "/pri/yunxi/getModule10kw",  //查询光伏组件10kW数据
    priYunxiGetModule10kwCurve: "/pri/yunxi/getModule10kwCurve",  //查询光伏组件10kW曲线数据
    priYunxiGetSysCurveEnergy: "/pri/yunxi/getSysCurveEnergy",  //查询总功率和日总发电量曲线
    priYunxiGetCurvePvSys: "/pri/yunxi/getCurvePvSys",  //查询总功率和日总发电量曲线
    priYunxiGetNetwork: "/pri/yunxi/getNetwork",  //查询网络量测数据

    //武威电站定制接口
    priWuweiGetSysCurveEnergy: "/pri/wuwei/getSysCurveEnergy",  //查询总功率和日总发电量曲线
    priWuweiGetSysCurveEnv: "/pri/wuwei/getSysCurveEnv",  //查询系统总览页面气象站曲线图，武威电站2的
    priWuweiGet5MWData: "/pri/wuwei/get5MWData",  //5MW光伏系统实证平台页面实时参数
    priWuweiGet5MWCurve: "/pri/wuwei/get5MWCurve",  //获取5MW光伏系统实证平台页面曲线数据
    priWuweiGet90kWData: "/pri/wuwei/get90kWData",  //获取90kW光伏组件及系统测试平台页面实时参数
    priWuweiGet90kWCurve: "/pri/wuwei/get90kWCurve",  //获取90kW光伏组件及系统测试平台页面曲线数据
    priWuweiGetEnv: "/pri/wuwei/getEnv",  //获取气象参数页面数据参数
    priWuweiGetEnvCurve: "/pri/wuwei/getEnvCurve",  //获取气象参数页面曲线数据
    priWuweiGet10kwData: "/pri/wuwei/get10kwData",  //获取10kW组件页面数据参数和MPR柱状图数据
    priWuweiGet10kwCurve: "/pri/wuwei/get10kwCurve",  //获取10kW组件页面曲线图数据
    priWuweiGetMeasurement: "/pri/wuwei/getMeasurement",  //获取10kW组件页面曲线图数据

    //浩哥测试项目接口定义
    hgStaCurveGetLatestRecord: "/cal/sta/ins/cur/getLatestRecord",  //根据曲线id查询最新一条记录值
    hgStaGetDeviceStateNum: "/his/getDeviceStateNum",  //获取运行设备数
    hgControl: "/sta/con/add",  //控制


    //点表控制项配置接口----->信
    getDotSurface: "/pt/getByStaId",//获取点表列表
    getDotTableInfo: "/pt/control/getList", //获取点表信息
    changeDotTableData: "/pt/control/alter", //修改控制点表配置数据
    getDetailInfo: "/pt/control/getOne", //根据id查询记录全信息
    removeDotTableAllInfo: "/pt/control/deleteMany",//删除
    addDotTableData: "/pt/control/add", //添加
    batchAddDotTableData: "/pt/control/batchAdd", //批量添加
    getYkPointList: "/pt/data/busGetListDownPoint", //获取点表遥控和遥调数据点(控制量)


    //拓扑图接口
    getTopologyOne: "/topology/getOne", //根据id查询记录全信息
    getTopologyList: "/topology/getList", //获取拓扑图列表
    deleteManyTopology: "/topology/deleteMany", //删除
    addTopology: "/topology/add",//添加
    alterTopology: "/topology/alter", //修改
    getHtml: "/topology/getTopologyHtmlByStationId", ///获取拓扑图的html字符串
    getTopologySwitch: "topologyPoin/getTopologyPoinBreakerByTopologyId", //获取图谱图断路器状态(目前没用)
    getTopologyData: "topologyPoin/getTopologyPoinByTopologyId",  //获取拓扑图数据点(目前没有用)
    getRealTimeData: "/topology/point/getRealTimeData",  //获取拓扑图实时数据(直接一次性返回状态和数据点,以上两个接口是单独返回的,所有没有用)

    //拓扑图显示配置接口 2024-9-9
    getTopologyModuleList:"/topology/module/getList", //获取拓扑图模块列表
    getTopologyModuleType:"/dict/getTopologyModuleType", //获取拓扑图模块类型(新)
    addTopologyModuleType:"/topology/module/add", //添加
    alterTopologyModuleType:"/topology/module/alter", //修改
    deleteTopologyModuleType:"/topology/module/deleteMany", //删除
    getOneTopologyModuleInfo:"/topology/module/getOne", //单记录查询


    //拓扑图代码接口
    getTopologyCodeOne: "/topology/html/getByTopologyId", //根据id查询记录全信息
    addOrAlterTopoCode: "/topology/html/addOrAlter", //添加或修改
    getRealTimeConfigNew: "/topology/module/getRealTimeConfigNew", //根据拓扑图id获取配置信息
    getRealTimeDataNew: "/topology/module/getRealTimeDataNew",//根据拓扑图id获取实时数据信息
    getTopologyHtmlNew: "/topology/module/getTopologyHtmlNew",
    
    //拓扑图数据点接口
    addTopologyPoint: "/topology/point/add", //拓扑图数据点新增
    alterTopologyPoint: "/topology/point/alter", //拓扑图数据点修改
    delTopologyPoint: "/topology/point/deleteMany", //拓扑图数据点删除
    getTopologyPointOne: "/topology/point/getOne", //获取单条拓扑图数据点
    getTopologyPointList: "/topology/point/getList", //获取拓扑图数据点列表
    addTopologyPointBatch:"/topology/point/batchAdd",
    
    //控制窗体
    getDevDataPoint: "/dev/getDevCtrlPointList", //获取设备数据点
    sendInstruct: "/dev/sendInstruct",  //发送指令
    sendInstructNew:"/dev/sendInstructNew", //发送指令新接口


    //电站角色管理
    getStatRoleList: "/sta/role/getList", //获取电站角色管理列表
    getRoleDetailInfo: "/sta/role/getOne", //根据id查询记录全信息
    addStatRole: "/sta/role/add", //添加电站角色
    removeStatRole: "/sta/role/delete", //删除电站角色
    alterStatRole: "/sta/role/alter", //修改电站角色
    getRoleDev: "/sta/role/dev/getList", //获取当前角色下的关联设备列表
    addDevRole: "/sta/role/dev/batchAdd", //批量添加设备角色
    addOneDevRole: "/sta/role/dev/add", //添加一条设备角色
    alterOneDevRole: "/sta/role/dev/alter", //修改一条设备角色
    deleteAllRoleDev: "/sta/role/dev/deleteMany", //根据角色id删除关联设备(支持全部删除和单个删除)
    removeDevRoleAll: "/sta/role/dev/delById", //根据角色id删除记录
    getControlPoint: "/pt/control/busGetList", //获取点表控制点(业务接口)
    getRoleData: "/sta/role/con/getList", //获取当前角色下的数据点
    alterOneDataRole: "/sta/role/con/alter", //修改一条数据点角色
    deleteDataRole: "/sta/role/con/deleteMany", //删除数据点关联角色(支持全部删除和单个删除)
    addOneDataRole: "/sta/role/con/add", //添加一条数据点角色
    addDataRole: "/sta/role/con/batchAdd", //批量添加数据点角色

    //点表配置模块
    getPointList: "pt/getList",//获取点表列表
    pointTableAdd: "pt/add", //添加点表
    getOnePointTable: "pt/getOne", //根据id查询单条记录
    pointTableAlter: "pt/alter",  //修改点表
    pointTableDelete: "pt/delete", //删除点表
    generatePtCode: "pt/generatePtCode", //自动获取点表编码

    //点表数据点配置模块
    getPointTableList: "pt/busGetList", //获取点表列表业务接口(获取条件不同-电站id和设备类型进行查询)
    getGroupList: 'pt/data/getGroupList', //获取数据点分组数据
    pointTableDataAdd: "pt/data/add", //添加点表数据点
    getPointTableDataList: 'pt/data/getList', //获取电表数据点列表
    getOnePointTableData: "pt/data/getOne", //根据id查询单条记录
    pointTableDataAlter: "pt/data/alter", //修改点表数据点
    pointTableDataDelete: "pt/data/deleteMany", //删除点表数据点
    pointDataExcelExport: "pt/data/dataImport",  //上传excel文件
    getDataPointbusGetList: "/pt/data/busGetList", //获取数据点下来列表(业务接口)
    getDataPointbusGetStateList: "/pt/data/busGetStateList", //获取数据点
    getDataPointListBus:"/pt/data/getAllPointList", //根据点表码获取数据点

    //数据显示配置模块
    getDataDisplayList: "/pt/data/display/getList", //查询数据显示配置列表
    dataPointBatchAdd: "/pt/data/display/batchAdd", //批量添加
    getOneDataDisplayInfo: "/pt/data/display/getOne", //根据id获取一条数据显示记录
    dataPointDisplayAlter: "/pt/data/display/alter", //修改
    dataPointDisplayAdd: "/pt/data/display/add", //添加单条
    dataPointDisplayDelete: "/pt/data/display/deleteMany", //删除

    //点表状态码配置
    getStateList: "/pt/state/getList", //获取点表状态点列表
    stateExport: "/pt/state/dataImport",//导入excel
    getOneStateInfo: "/pt/state/getOne",//查询一条记录信息State
    stateAlter: "/pt/state/alter", //修改
    stateAdd: "/pt/state/add", //添加
    stateDelete: "/pt/state/deleteMany", //删除

    //点表告警码配置
    getAlarmList: "/pt/alarm/getList", //获取点表告警列表
    getAlarmBusList: "/pt/alarm/busGetList", //获取点表告警列表
    alarmExport: "/pt/alarm/dataImport", //导入excel文件
    getDataPointBusGetCodeList: "/pt/data/busGetCodeList", //获取为告警码和告警码点表数据点
    alarmAdd: "pt/alarm/add", //添加
    getOneAlarmInfo: "pt/alarm/getOne", //查询一条记录
    alarmAlter: "pt/alarm/alter", //修改
    alarmDelete: "pt/alarm/deleteMany", //删除

    //数据存储表配置
    getDataStoreList: "dt/getList", //查询数据存储列表
    getDataStorebusGetList: "dt/busGetList", //查询数据存储列表
    addDataStorePoint: "dt/add", //添加
    alterDataStorePoint: "dt/alter", //修改
    getOneDataStorePointInfo: "dt/getOne", //查询单条记录信息
    deleteDataStorePoint: "dt/deleteMany", //删除

    //设备配置
    getDevList: "dev/getList", //获取设备列表
    getOneDataDevInfo: "dev/getOne", //查询单条记录
    deleteDev: "dev/deleteMany", //删除
    alterDev: "dev/alter", //修改
    addDev: "dev/add", //增加
    getDevListNew: "dev/busGetListByStaId", //根据电站id查询设备列表(业务接口)
    getDevListBus: "dev/busGetList", //根据电站id和点表码查询设备列表(业务接口)

    //电站配置
    getStationList: "sta/getList", //查询电站列表
    getOneDataStationInfo: "sta/getOne", //查询单条记录
    addStation: "sta/add", //增加
    alterStation: "sta/alter", //修改
    deleteStation: "sta/deleteMany", //删除
    getBusGetOne: "sta/busGetOne", //业务接口(获取一个电站的静态信息)
    getDevAndTypeByStaIdList: "/sta/getDevAndTypeByStaIdList", //获取电站下有反馈点的设备类型和设备
    getStaDevAndTypeList: "/sta/getCtlDevAndTypeByStaIdList", //获取控制窗口左侧菜单的设备类型和设备
    getBusGetStaInfo: "/sta/busGetStaInfo", //获取电站的静态信息

    getBusGetListByStationGroup: "/sta/busGetListByStationGroup/",//根据分组id查询电站列表

    //电站分组
    getStationGroupList: "sta/group/getList",//获取分组列表
    addStationGroup: "sta/group/add",//增加
    alterStationGroup: "sta/group/alter",//修改
    deleteStationGroup: "sta/group/deleteMany",//删除
    getStationGroupOne: "sta/group/getOne",//查询单条记录
    getStationGroupRelatedList: "/sta/group/related/getList",//获取分组列表

    //电站分组关联
    addStationGroupRelated: "/sta/group/related/add",
    batchAddStationGroupRelated: "sta/group/related/batchAdd",
    alterStationGroupRelated: "/sta/group/related/alter",
    deleteStationGroupRelated: "/sta/group/related/deleteMany",
    getStationGroupRelatedOne: "/sta/group/related/getOne",

    //电站静态信息
    getInfoModuleType:"/dict/getInfoModuleType", //获取信息模块类型
    getStationInfoList: "sta/static/info/getList",
    getStationInfoOne: "sta/static/info/getOne",
    addStationInfo: "sta/static/info/add",
    alterStationInfo: "sta/static/info/alter",
    deleteStationInfo: "sta/static/info/deleteMany",
    getStaticInfoBus:"/sta/static/info/busGetList", //获取电站的静态信息业务接口

    //电站配置信息
    getStationConfigList: "sta/config/info/getList",
    getStationConfigOne: "sta/config/info/getOne",
    addStationConfig: "sta/config/info/add",
    alterStationConfig: "sta/config/info/alter",
    deleteStationConfig: "sta/config/info/deleteMany",
    getConfigInfoBus:"/sta/config/info/busGetList", //获取电站的配置信息业务接口
    
    //控制器配置
    getControlList: "/ctrl/getList",  //获取控制器列表
    deleterControl: "/ctrl/deleteMany", //删除
    addControl: "/ctrl/add", //增加
    alterControl: "/ctrl/alter", //修改
    getOneControlInfo: "/ctrl/getOne", //查询单条记录
    getControlId: "ctrl/busGetList", //获取控制器id


    //设备详情
    getDevDataInfo: "/dev/getFeedbackPoint", //设备详情页获取设备配置信息
    getDevDetailConfigList:"/dev/getFeedbackPointNew", //获取设备详参的配置列表(新接口)
    getDevNewOneRecord: "/dev/getDevNewOneRecord", //设备详情页加载实时数据
    getDevRealTimeData: "/dev/getDevRealTimeData", //设备详情页加载实时数据(新接口)

    //智慧储能云服务平台
    getStationStatic: "/sta/info/busGetList", //获取终端规模的静态信息
    getGridData: "own/sta/rt/data/busGetList", //获取并网点数据
    getGridChart: "/chart/getChartCodeChartList", //获取曲线图
    getChartDataListByStaChartId: "/chart/data/getDataListByChartIdAndStaId", //查询曲线数据
    getLatestRecord: "/cal/sta/ins/cur/getLatestRecord", //(好像没用到)
    busGetDataList: "own/sta/rt/data/busGetDataList", //获取实时数据
    busGetDataListNew: "own/sta/rt/data/busGetDataListNew", //获取实时数据(新接口)
    getDeviceStatusStatistics: "/sta/getDeviceStatusStatistics", //获取设备统计数据
    getListByEmsSign: "sta/busGetListByEmsSign",//获取有EMS电站列表
    getListByStaId: "/own/sta/rt/data/busGetListByStaId",//根据电站id获取设备列表
    getStationImg: "/img/getImageList", ///获取电站图片(返回base64格式)
    getStaImgList: "/img/getStaImgList", ///获取电站图片(返回图片链接地址)
    getEMSStaImgList:"/img/getEMSStaImgList", //获取EMS电站背景图片
    getEMSStationImageList: "/img/getEMSStationImageList", //获取ems背景图片
    getEmsConfigData:"/own/sta/rt/data/busGetCfgList", //获取ems的配置数据
    getEmsRealData:"/own/sta/rt/data/busGetRtdList", //根据电站id和模块类型加载实时数据
    getEmsDevList:"/own/sta/rt/data/busGetDevList", //查询设备列表

    //历史告警
    getRealAlarmList: "/alarm/getList",//获取告警列表
    alarmConfirm: '/alarm/busConfirm', //告警确认
    getOneRealAlarmInfo: "/alarm/getOne", //查询一条告警信息

    //原始变位数据
    getDisplaceDataList: "/sta/displace/getList", //查询原始变位数据列表
    displaceGetListPage: "/sta/displace/getListPage",    //变位数据(新接口)
    // getOneDisplaceData:"/sta/displace/getOne", //查询单条变位数据(暂时不用)

    // 原始跳变数据
    getChangeDataList: "/sta/change/getList", //查询原始数据跳变数据
    changeGetListPage: "/sta/change/getListPage",  //查询原始数据跳变数据(新接口)
    // getOneChangeData:"/sta/change/getOne", //查询单条跳变数据(暂时不用)

    //原始告警变位数据
    getAlarmDisplaceDataList: "/sta/alarm/displace/getList",  //获取原始数据告警变位数据列表
    alarmGetListPage: "/sta/alarm/displace/getListPage",//获取实时告警列表(新接口)
    // getOneAlarmDisplaceData:"/sta/alarm/displace/getOne" ,//获取单条告警变位数据(暂时没用)

    //权限管理模块(角色管理)
    getRoleList: "/role/getList", //获取角色列表
    getOneRoleInfo: "/role/getOne", //获取一条角色信息
    addRole: "/role/add", //添加角色
    alterRole: "/role/alter", //添加角色
    deleteRole: "/role/deleteMany", //删除角色
    getBusRoleList: "/role/busGetList", //业务获取角色列表
    getRoleAndPermissionRele: "/role/permission/getList",// 查询角色和权限已经关联的
    deleteRoleAndPermission: "/role/permission/deleteMany",// 删除角色和权限已经关联的
    addRoleAndPermission: "/role/permission/add",// 添加角色和权限关联
    batchAddRoleAndPermission: "/role/permission/batchAdd",// 添加角色和权限关联

    //权限管理模块(菜单管理)
    getMenuList: "/menu/getList", //获取菜单列表
    getMenuListTree: "/menu/getListTree", //获取菜单列表树
    getOneMneuInfo: "/menu/getOne", //获取一条菜单信息
    addMneu: "/menu/add", //添加菜单
    alterMenu: "/menu/alter", //修改菜单
    deleteMenu: "menu/deleteMany", //删除菜单
    getMenuAndPermission: "/permission/menu/getList",// 查询菜单和权限已经关联的
    deleteMenuAndPermission: "/permission/menu/deleteMany",// 删除角色和权限已经关联的
    addMenuAndPermission: "/permission/menu/add",// 添加角色和权限关联
    batchAddMenuAndPermission: "/permission/menu/batchAdd",// 批量添加角色和权限关联
    getBusMenuList: "/menu/busGetList", //业务接口根据系统类型获取菜单列表
    getPrivateStatMenuList: "/menu/busGetPrivateList", //获取私有电站的所有菜单列表
    getBusGetPublicList: "/menu/busGetPublicList",//根据系统类型获取菜单列表

    //权限管理模块(权限管理)
    getPermissionList: "/permission/getList", //获取权限列表
    getOnePermissionInfo: "/permission/getOne", //获取一条权限信息
    addPermission: "/permission/add", //添加权限
    alterPermission: "/permission/alter", //修改权限
    deletePermission: "/permission/deleteMany", //删除权限
    getBusPermissionList: "/permission/busGetList", //业务接口,获取权限列表

    //权限管理模块(按钮管理)
    getButtonList: "/button/getList", //获取按钮列表
    getButtonListTree: "/button/getListTree", //获取按钮列表
    getButtonAndPermission: "/permission/button/getList",// 查询按钮和权限已经关联的
    deleteButtonAndPermission: "/permission/button/deleteMany",// 删除按钮和权限已经关联的
    addButtonAndPermission: "/permission/button/add",// 添加按钮和权限关联
    batchAddButtonAndPermission: "/permission/button/batchAdd",// 批量添加按钮和权限关联
    getOneButtonInfo: "/button/getOne", //获取一条按钮信息
    addButton: "/button/add", //添加按钮
    alterButton: "/button/alter", //修改按钮
    deleteButton: "/button/deleteMany", //删除按钮
    getBusButtonList: "/button/busGetList", //根据系统类型获取按钮列表的业务接口

    //权限管理模块(控制角色)
    getCtrlRoleAndPermission: "/permission/ctrl/role/getList", //获取控制角色和权限已经关联的
    deleteCtrlRoleAndPermission: "/permission/ctrl/role/deleteMany", //删除控制角色和权限已经关联的
    addCtrlRoleAndPermission: "/permission/ctrl/role/add",// 添加按钮和权限关联
    batchAddCtrlRoleAndPermission: "/permission/ctrl/role/batchAdd",// 批量添加按钮和权限关联

    //权限管理模块(电站菜单关联)
    getStatAndMenu: "/station/menu/getList", //获取已经跟电站关联的菜单
    deleteStatAndMenu: "/station/menu/deleteMany", //删除电站和菜单已经关联的
    addStatAndMenu: "/station/menu/add", //添加电站和菜单的关联
    batchAddStatAndMenu: "/station/menu/batchAdd", //批量添加电站菜单

    getRouterHome: "/menu/route/busGetList", //根据系统类型获取路由的主home路由配置

    //获取曲线图数据(新接口,根据图表id直接加载数据)
    getChartHourDataNew: "/new/chart/data/getChartHourDataNew",
    getChartDayDataNew: "/new/chart/data/getChartDayDataNew",
    getChartMonthDataNew: "/new/chart/data/getChartMonthDataNew",
    getChartYearDataNew: "/new/chart/data/getChartYearDataNew",


    //单位管理
    getCompanyList: "/com/getList", //获取单位列表
    addCompany: "/com/add", //添加单位
    alterCompany: "/com/alter", //修改单位
    deleteCompany: "/com/deleteMany", //删除单位
    getOneCompanyInfo: "/com/getOne", //查询一条单位信息
    getCompanyAndStatMenu: "/station/company/getList", //获取单位和电站菜单已经关联的
    deleteCompanyAndStatMenu: "/station/company/deleteMany", //删除单位和电站菜单已经关联的
    addCompanyAndStatMenu: "/station/company/add", //添加单位和电站菜单已经关联的
    batchAddCompanyAndStatMenu: "/station/company/batchAdd", //批量添加单位和电站菜单已经关联的
    getComTreeList: "/com/getListTree", //获取单位树管理接口
    getBusComTreeList: "/com/getBusListTree", //获取单位树业务接口

    //第三方接口
    getExternalUserList: "/external/user/getList", //获取用户列表
    getOneExternalUserInfo: "/external/user/getOne", //获取一条用户信息
    addExternalUserInfo: "/external/user/add", //添加一条用户信息
    alterExternalUserInfo: "/external/user/alter", //修改一条用户信息
    deleteExternalUserInfo: "/external/user/delete", //删除用户
    getPasswordKey: "/external/user/generatePasswordKey", //生成密码密钥
    addExternalDevPer: "/external/device/add", //新增加一条设备权限
    batchAddExternalDevPer: "/external/device/addBatch", //批量添加设备权限
    deleteExternalDevPer: "/external/device/delete", //删除设备权限
    getExternalAlloDevPer: "/external/device/busGetList", //查询已经分配的设备集合
    getExternalAllostationPer: "/external/device/getUserStaIdList", //查询已经分配的电站集合

    getExternalStateSign: "/dict/getExternalStateSign",//获取第三方账号状态标记
    getExternalConnState: "/dict/getExternalConnState",//获取第三方API账号连接状态
    getExternalLoginType: "/dict/getExternalLoginType",//获取第三方API账号登录状态类型
    getExternalResultType: "/dict/getExternalResultType", //获取第三方API账号请求结果标记

    getExternalLoginData: "/log/api/user/login/getList", //获取第三方账号的登录日志
    getExternalrequestData: "/log/api/user/request/getList", //获取第三方请求日志


    //图表管理
    addChart: '/chart/add',//添加
    alterChart: '/chart/alter',//修改
    deleteManyChart: '/chart/deleteMany',//删除
    getChartList: '/chart/getList',//查询图表列表
    getOneChartInfo: "/chart/getOne", //查询一条图表信息
    getChartNewlineSign:"/dict/getChartNewlineSign", //获取图表的折行标记字典

    //图标数据关联
    getChartDataReleList: "/chart/data/getList", //查询图表数据
    addChartDataRele: "/chart/data/add", //添加图表数据关联
    alterChartDataRele: "/chart/data/alter", //修改图表数据关联
    deleteChartDataRele: "/chart/data/deleteMany", //删除图表数据关联
    getOneChartDataReleInfo: "/chart/data/getOne", //查询一条关联信息

    //EMS实时数据配置
    getEMSConfigList: "/own/sta/rt/data/getList", //获取数据配置列表
    addEMSConfig: "/own/sta/rt/data/add", //添加数据配置
    alterEMSConfig: "/own/sta/rt/data/alter", //修改数据配置
    deleteEMSConfig: "/own/sta/rt/data/deleteMany", //删除数据配置
    getOneEMSConfigInfo: "/own/sta/rt/data/getOne", //查询一条数据配置信息


    //电价管理
    addEP: '/electricity/price/add',//添加
    alterEP: '/electricity/price/alter',//修改
    deleteManyEP: '/electricity/price/deleteMany',//删除
    getEPList: '/electricity/price/getList',//查询电价列表
    getOneEPInfo: '/electricity/price/getOne',//查询一条电价信息

    //电价节点管理
    addEPNode: '/electricity/price/node/add',//添加
    alterEPNode: '/electricity/price/node/alter',//修改
    deleteManyEPNode: '/electricity/price/node/deleteMany',//删除
    busGetEPNodeList: '/electricity/price/node/busGetList',//业务模块查询数据集合
    addBatch: '/electricity/price/node/addBatch',//批量添加
    alterBatch: '/electricity/price/node/alterBatch',//批量修改


    //累积量配置管理
    getCumulateList: "/sta/cumulate/getList", //获取累积量列表
    getOneCumulateInfo: "/sta/cumulate/getOne", //根据id查询一条信息
    addCumulate: "/sta/cumulate/add", //添加累积量
    alterCumulate: "/sta/cumulate/alter", //修改累积量
    deleteCumulate: "/sta/cumulate/deleteMany", //删除累积量
    getCumulateListBus:"/sta/cumulate/getListBus", //获取累积量列表业务接口

    //累积量节点配置
    getCumulateNodeList: "/sta/cumulate/node/getList", //获取累积量节点列表
    deleteCumulateNode: "/sta/cumulate/node/deleteMany", //删除累积量节点
    addCumulateNode: "/sta/cumulate/node/add", //添加累积量节点
    alterCumulateNode: "/sta/cumulate/node/alter", //修改累积量节点
    getOneCumulateinfo: "/sta/cumulate/node/getOne", //查询单条


    //新接口
    loginPc: "/user/loginPcAccPass", //登录pc端
    getRouteHomeByPermission: "/menu/route/getRouteHomeByPermission",//加载路由
    getMenuByPermission: "/menu/getMenuByPermission", //加载权限菜单(不读缓存)
    getMenuByCacheOrData:"/menu/getMenuByCacheOrData", //加载权限菜单(读缓存)
    getStationByPermission: "/sta/getStationByPermission", //针对权限管理加载系统菜单新添加的接口, 获取综合监控下的左侧的电站菜单
    getStationByCompanyId:"/sta/getStationByCompanyId", //根据单位id查询改单位下所有的电站

    //图片管理
    getStationImgList:"/img/getList", //查询图片的列表
    addStationImg:"/img/add", //添加
    alterStationImg:"/img/alter", //修改
    deleteStationImg:"/img/deleteMany", //删除
    getOneImgInfo:"/img/getOne", //查询单条图片信息
    getImgSize:"/dict/getImgFileSize", //获取限制图片的大小,
    getStationImgListBus:"/img/busGetList", //业务接口,查询图片列表

    // 图表新接口
    getChartConfig:"/chart/getChartCfg", //读取图表的配置信息
    getChartDataByChartId:"/chart/getChartData", //根据图表id查询曲线数据

    // iems的数据配置管理
    getDataModuleType:"/dict/getDataModuleType", //获取数据显示的模块类型
    getIemsDataList:"/sta/data/display/getList", //IEMS电站数据显示接口
    addIemsData:"/sta/data/display/add", //添加IEMS电站显示数据
    addBatchIemsData:"/sta/data/display/addBatch", //批量添加IEMS电站显示数据
    getIemsOneInfo:"/sta/data/display/getOne",//查询单条记录
    alterIemsData:"/sta/data/display/alter", //修改IEMS电站显示数据
    deleteIemsData:"/sta/data/display/deleteMany", //删除IEMS电站显示数据
    getDataModuleSign:"/dict/getDataModuleSign", //获取数据的模块标记
    getDataSourceType:"/dict/getDataSourceType", //获取数据的源类型
    getIEMSModuleDisData:"/sta/data/display/getStaOverview", //IEMS电站-系统概览（地图模式和列表模式）
    getDisRealData:"/sta/data/display/getDisRealData", //实时数据
    getCodeIndexListMap:"/pt/alarm/busGetMap", //通过点表码查询码索引

    //电站的实时曲线配置
    getStatRealCurveList:"/sta/rt/curve/getList", //查询电站实时曲线配置列表
    addStatRealCurve:"/sta/rt/curve/add", //添加
    alterStatRealCurve:"/sta/rt/curve/alter", //修改
    deleteStatRealCurve:"/sta/rt/curve/deleteMany", //删除
    getOnestatRealCurveInfo:"/sta/rt/curve/getOne", //查询单条配置信息
    getCurveSourceType:"/dict/getCurveSourceType", //获取曲线的模块类型

    //厂家管理
    getFactoryList:"/factory/getList", //查询厂家列表
    getFactoryBusList:"/factory/busGetList", //查询厂家列表业务接口
    addFactory:"/factory/add", //添加
    alterFactory:"/factory/alter", //编辑
    deleteFactory:"/factory/deleteMany", //删除
    getOneFactory:"/factory/getOne",//查询单条
    getFactoryType:"/dict/getFactoryType", //获取厂家类型字典

    //型号管理
    getModelList:"/model/getList", //查询型号列表
    addModel:"/model/add", //添加
    alterModel:"/model/alter", //编辑
    deleteModel:"/model/deleteMany", //删除
    getOneModelInfo:"/model/getOne",//查询单条

    //地址管理
    getAddressList:"/address/getList", //查询地址列表
    addAddress:"/address/add", //添加
    alterAddress:"/address/alter", //编辑
    deleteAddress:"/address/deleteMany", //删除
    getOneAddressInfo:"/address/getOne",//查询单条
    getAddressLevel:"/dict/getAddressLevel", //获取地址等级
    getAddressStateSign: "/dict/getAddressStateSign", //获取地址的使用状态标记

    // 登录日志
    getLoginLogList:"/log/login/getList", //查询登录登出日志列表
    getLogLoginTerminalType:"/dict/getLogLoginTerminalType", //获取登录的终端类型\
    getLogLoginWay:"/dict/getLogLoginWay", //获取登录方式
    getLogLoginCurrentState:"/dict/getLogLoginCurrentState", //获取账号当前的登录状态

    // 调控日志
    getControlLogsList:"/log/control/getList", //查询控制日志列表
    getResultList:"/dict/getLogControlResult", //获取控制日志页面下发结果字典

    //单位静态信息
    getComInfoList:"/com/info/getList", //查询单位静态信息列表
    getOneComInfo:"/com/info/getOne", //查单条单位静态信息
    addComInfo:"/com/info/add", //新增单位静态信息
    alterComInfo:"/com/info/alter", //修改单位静态信息
    deleteComInfo:"/com/info/deleteMany", //删除单位静态信息

    //图片关联模块
    getImgModuleType:"/dict/getImgModuleType", //查询图片的模块类型
    getImgModuleSign:"/dict/getImgModuleSign", //查询图片的模块标记
    getRelevanceImgList:"/img/module/getList", //查询图片关联列表
    getOneRelevanceImgInfo:"/img/module/getOne", //根据记录id查询单条
    addRelevanceImg:"/img/module/addBatch", //添加
    alterRelevanceImg:"/img/module/alter", //修改
    deleteRelevanceImg:"/img/module/deleteMany", //删除
    getImgDisplayOperateSign:"/dict/getImgOperateSign", //获取图片显示的操作标记
    getImgDisplayList:"/img/display/getList", //获取图片显示配置列表
    alterImgDisplayInfo:"/img/display/alter", //修改图片显示信息


    IEMSGeneralDataApi:"/sta/data/display/getGeneralData",// IEMS-通用数据（不分页）
    getDevCardData:"/sta/data/display/getDevCardData",// 获取设备卡片（不分页）
    getRtCurveConfig:"/sta/rt/curve/getRtCurveConfig",// 获取实时曲线配置
    getRtCurveData:"/sta/rt/curve/getRtCurveData",// 获取实时曲线
    getStaCardDataToMap:"/sta/data/display/getStaCardDataToMap",// 获取电站卡片数据-地图模块
    getDevStateStatistics:'/sta/data/display/getDevStateStatistics',//查询电站下所有设备状态信息

    //电站任务管理模块
    getExecuteType:"/dict/getExecuteType", //获取任务的执行类型
    getTaskState:"/dict/getTaskState", //获取任务的当前状态
    getTaskList:"/instruct/task/getList", //获取任务列表
    addTask:"/instruct/task/add", //添加任务
    alterTask:"/instruct/task/alter", //修改任务
    deleteTask:"/instruct/task/deleteMany", //删除任务
    getOneTaskInfo:"/instruct/task/getOne", //根据id查询单条任务信息
    startTask:"/instruct/task/start", //启动任务
    stopTask:"/instruct/task/stop", //停止任务
    getTaskNodeList:"/instruct/point/getList", //获取任务节点列表
    addTaskNode:"/instruct/point/add", //添加任务节点
    alterTaskNode:"/instruct/point/alter", //修改任务节点
    deleteTaskNode:"/instruct/point/deleteMany", //删除任务节点
    getOneTaskNodeInfo:"/instruct/point/getOne", //根据查询单条任务节点洗信息
    importTaskNode:"/instruct/point/import", //导入任务节点
    exportTaskNode:"/instruct/point/export", //导出任务节点
    downTaskNodeTemplate:"/instruct/point/downTemplate", //下载任务节点模版
    getTaskRealData:"/instruct/task/getRtDataById", //获取任务的实时数据
    getTaskNodeRealData:"/instruct/point/getRtDataById", //获取任务节点的实时数据

    //模拟数据模块
    getTaskRunModel:"/dict/getTaskRunModel", //获取任务的运行模式字典
    getSimulateTaskList:"/simulate/task/getList", //获取模拟任务列表
    addSimulateTask:"/simulate/task/add", //添加模拟任务
    alterSimulateTask:"/simulate/task/alter", //修改模拟任务
    deleteSimulateTask:"/simulate/task/deleteMany", //删除模拟任务
    getOneSimulateTaskInfo:"/simulate/task/getOne", //根据id查询单条
    startSimulateTask:"/simulate/task/start", //启动模拟任务
    stopSimulateTask:"/simulate/task/stop", //停止模拟任务
    // 模拟数据设备模块
    getSimulateDevList:"/simulate/device/getList", //获取模拟数据设备
    deleteSimulateDev:"/simulate/device/deleteMany", //删除模拟设备
    addSimulateDev:"/simulate/device/add", //添加模拟设备
    addBatchSimulateDev:"/simulate/device/addBatch", //批量添加模拟设备
    //模拟数据点配置模块
    getSimulateConfigTypeList:"/dict/getSimulateConfigType", //获取模拟配置类型字典
    getSimulateTypeList:"/dict/getSimulateType", //获取模拟类型字典
    getSimulateFormulaSign:"/dict/getFormulaSign", //获取公式标记字典
    getSimulateDataPointConfigList:"/simulate/point/getList", //获取模拟数据点配置列表
    getSimulateDataPointConfigBusList:"/simulate/point/busGetList", //获取模拟数据点配置列表业务
    deleteSimulateDataPointConfig:"/simulate/point/deleteMany", //删除模拟数据点配置
    alterSimulateDataPointConfig:"/simulate/point/alter", //编辑模拟数据点配置
    addSimulateDataPointConfig:"/simulate/point/add", //添加模拟数据点配置
    addBatchSimulateDataPointConfig:"/simulate/point/addBatch", //批量添加模拟数据点配置
    getOneSimulateDataPointConfigInfo:"/simulate/point/getOne", //根据id查询单条模拟数据点配置信息
    getSimulateDataTimeSignList:"/dict/getSimulateDataTimeSign", // 获取模拟数据时间标记字典
    getSimulateReduceSecondList:"/dict/getSimulateReduceSecond", //获取模拟导入点数据查询偏移秒

    //模拟点数据模块
    getIntermittentSign:"/dict/getIntermittentSign", //获取断续标记
    getSimulateDataList:"/simulate/data/getList", //获取模拟数据列表
    addSimulateData:"/simulate/data/add", //添加模拟数据
    alterSimulateData:"/simulate/data/alter", //修改模拟数据
    deleteSimulateData:"/simulate/data/deleteMany", //删除模拟数据
    getOneSimulateDataInfo:"/simulate/data/getOne", //根据id查询单条模拟数据信息
    getSimulateDataListBus:"/simulate/data/busGetList", //获取模拟数据业务接口
    //模拟数据点模块
    getSimulatePointList:"/simulate/data/point/getList", //查询模拟数据点的列表
    addSimulatePoint:"/simulate/data/point/add", //添加模拟数据点的列表
    alterSimulatePoint:"/simulate/data/point/alter", //修改模拟数据点
    deleteSimulatePoint:"/simulate/data/point/deleteMany", //删除模拟数据点
    getOneSimulatePointInfo:"/simulate/data/point/getOne", //根据id查询单条模拟点的数据信息
    importSimulatePoint:"/simulate/data/point/import", //导入模拟点
    downSimulatePointTemplate:"/simulate/data/point/importTemplate", //下载导入模版
    exportSimulatePoint:"/simulate/data/point/export", //导出
    //模拟数据点规则模块
    getSimulateCumulateSignList:"/dict/getSimulateCumulateSign", //获取模拟累积量标记
    getRoundSign:"/dict/getRoundSign", //获取取整标记
    getSimulateRuleList:"/simulate/point/rule/getList", //获取模拟点规则列表
    getSimulateRuleBusList:"/simulate/point/rule/busGetList", //获取模拟点规则列表
    addSimulateRule:"/simulate/point/rule/add", //添加模拟点规则
    alterSimulateRule:"/simulate/point/rule/alter", //修改模拟点规则
    deleteSimulateRule:"/simulate/point/rule/deleteMany", //删除模拟点规则
    getOneSimulateRuleInfo:"/simulate/point/rule/getOne", //根据id查询单条模拟点规则信息
    getSimulateRuleType:"/dict/getSimulateRuleType", //获取模拟规则类型字典

    getEMSDeviceList:"/sta/data/display/getEMSDeviceList", //IEMS-EMS页面设备总数数量统计
    getNormalDevStateStatistics:'/sta/getNormalDevStateStatistics', //IEMS-EMS页面设备正常数量统计
    getDevStateIEMS:"/sta/getDevState", //IEMS-系统总览-设备卡片状态

    getCommSign:"/dict/getCommSign", //设备检测标记
    deviceComStatusList:"/sta/dev/comm/state/getList",//设备通讯状态列表
    getBusGetList:"/sta/dev/comm/state/busGetList",//查询已添加通讯状态标记的设备
    addDevComStatusFlag:"/sta/dev/comm/state/add",//单条添加设备通讯状态标记
    batchAddDevComStatusFlag:"/sta/dev/comm/state/batchAdd",//批量添加设备通讯状态标记
    delDevComStatusFlag:"/sta/dev/comm/state/deleteMany",//删除设备通讯状态标记
    devComStatusGetOne:'/sta/dev/comm/state/getOne',//查询单条设备通讯状态
    editDevComStatus:'/sta/dev/comm/state/alter',//编辑设备通讯状态

    getDevStateSign:"/dict/getDevStateSign",//设备状态标记
    getDevStatusList:"/sta/dev/state/getList",//设备状态列表
    addDevStatus:"/sta/dev/state/add",//单条添加设备状态
    batchAddDevStatus:"/sta/dev/state/batchAdd",//批量添加设备状态
    devStatusGetOne:"/sta/dev/state/getOne",//查询单条设备状态
    editDevStatus:"/sta/dev/state/alter",//编辑设备状态
    delDevStatusFlag:"/sta/dev/state/deleteMany",//删除设备状态
    
    devStatRuleList:"/sta/dev/state/rule/getList",// 设备状态规则列表
    addDevStatRule:"/sta/dev/state/rule/add",// 添加设备状态规则
    alterDevStatRule:"/sta/dev/state/rule/alter",//编辑设备状态规则
    delDevStatRule:"/sta/dev/state/rule/deleteMany",// 删除设备状态规则
    devRuleGetOne:"/sta/dev/state/rule/getOne",//查询单条设备状态规则
    
    getStateRuleDataType:"/dict/getStateRuleDataType", //获取数据类型字典
    getStateRuleType:"/dict/getStateRuleType",//获取校验类型字典
    getStateRuleSymbol:"/dict/getStateRuleSymbol",//获取校验逻辑关系字典

    disGetListNew:"/sta/displace/getListNew", //变位数据查询
    changeGetListNew:"/sta/change/getListNew", //变化数据查询
    alarmGetListNew:"/alarm/getListNew", //告警数据查询
    
    primitiveGetListNew:"/dev/his/getDevHisDataList",//原始数据查询
    getHisChartTypeDataNew:"/cal/sta/ins/cur/getHisChartTypeDataNew", //根据瞬时量id集合、设备id集合、时间查询图表类型数据(新)

    getEMSWeatherSign:"/dict/getEMSWeatherSign", //获取EMS天气显示标记

    //模拟数据模块1.0(新版本)
        // 任务管理
    getSimulateTaskListNew:"/new/simulate/task/getList", //获取模拟任务列表
    addSimulateTaskNew:"/new/simulate/task/add", //添加模拟任务
    alterSimulateTaskNew:"/new/simulate/task/alter", //修改模拟任务
    deleteSimulateTaskNew:"/new/simulate/task/deleteMany", //删除模拟任务
    getOneSimulateTaskInfoNew:"/new/simulate/task/getOne", //根据id查询单条
    startSimulateTaskNew:"/new/simulate/task/start", //启动模拟任务
    stopSimulateTaskNew:"/new/simulate/task/stop", //停止模拟任务
        // 模拟数据设备模块
    getSimulateDevListNew:"/new/simulate/device/getList", //获取模拟数据设备
    deleteSimulateDevNew:"/new/simulate/device/deleteMany", //删除模拟设备
    addSimulateDevNew:"/new/simulate/device/add", //添加模拟设备
    addBatchSimulateDevNew:"/new//simulate/device/addBatch", //批量添加模拟设备
        // 模拟数据点配置模块
    getSimulateDataPointConfigListNew:"/new/simulate/point/getList", //获取模拟数据点配置列表
    getSimulateDataPointConfigBusListNew:"/new/simulate/point/busGetList", //获取模拟数据点配置列表业务
    deleteSimulateDataPointConfigNew:"/new/simulate/point/deleteMany", //删除模拟数据点配置
    alterSimulateDataPointConfigNew:"/new/simulate/point/alter", //编辑模拟数据点配置
    addSimulateDataPointConfigNew:"/new/simulate/point/add", //添加模拟数据点配置
    addBatchSimulateDataPointConfigNew:"/new/simulate/point/addBatch", //批量添加模拟数据点配置
    getOneSimulateDataPointConfigInfoNew:"/new/simulate/point/getOne", //根据id查询单条模拟数据点配置信息
        //导入点数据列表
    getShareSignList: "/dict/getShareSign",
    getSimulateDataListNew:"/new/simulate/data/getList", //获取模拟数据列表
    addSimulateDataNew:"/new/simulate/data/add", //添加模拟数据
    alterSimulateDataNew:"/new/simulate/data/alter", //修改模拟数据
    deleteSimulateDataNew:"/new/simulate/data/deleteMany", //删除模拟数据
    getOneSimulateDataInfoNew:"/new/simulate/data/getOne", //根据id查询单条模拟数据信息
    getSimulateDataListBusNew:"/new/simulate/data/busGetList", //获取模拟数据业务接口
        //导入点数据节点
    getSimulatePointListNew:"/new/simulate/data/point/getList", //查询模拟数据点的列表
    addSimulatePointNew:"/new/simulate/data/point/add", //添加模拟数据点的列表
    alterSimulatePointNew:"/new/simulate/data/point/alter", //修改模拟数据点
    deleteSimulatePointNew:"/new/simulate/data/point/deleteMany", //删除模拟数据点
    getOneSimulatePointInfoNew:"/new/simulate/data/point/getOne", //根据id查询单条模拟点的数据信息
    importSimulatePointNew:"/new/simulate/data/point/import", //导入模拟点
    downSimulatePointTemplateNew:"/new/simulate/data/point/importTemplate", //下载导入模版
    exportSimulatePointNew:"/new/simulate/data/point/export", //导出

}
export default myApi
